import { render, staticRenderFns } from "./riskSplit.vue?vue&type=template&id=4ad6d872&"
import script from "./riskSplit.vue?vue&type=script&lang=js&"
export * from "./riskSplit.vue?vue&type=script&lang=js&"
import style0 from "./riskSplit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports